import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Typography } from '@material-ui/core';

import FormInput from 'Console/components/common/form/FormInput';

// Others
import { policyRegex, uppercaseRegex, numericRegex, PASSWORD_MIN_LENGTH } from 'Console/utils/formUtils';

const styles = (theme) => ({
    root: {
        margin: '42px 48px',
        [theme.breakpoints.between('xs', 'sm')]: {
            margin: '42px 48px',
            display: 'flex',
            'flex-direction': 'column',
        },
    },
    formName: {
        width: '20%',
        marginRight: '5%',
        [theme.breakpoints.between('xs', 'sm')]: {
            width: '100%',
            marginRight: 0,
        },
    },
    items: {
        paddingBottom: '4%',
        'align-items': 'center',
        'justify-content': 'center',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            marginRight: 0,
            paddingBottom: 0,
        },
    },
    formInput: {
        width: '47%',
        [theme.breakpoints.between('xs', 'sm')]: {
            width: '100%',
            marginBottom: '5%',
        },
    },
});

class RegisterUser extends Component {
    state = {
        confirmDirty: false,
    };

    handleConfirmBlur = () => {
        const { confirmDirty } = this.state;
        if (!confirmDirty) {
            this.setState({ confirmDirty: true });
        }
    };

    compareToFirstPassword = (rule, value, callback) => {
        const {
            form,
            intl: { formatMessage },
        } = this.props;

        if (value && value !== form.getFieldValue('registerUserPassword')) {
            callback(
                formatMessage({
                    id: 'Form.passwordInconsistent',
                    defaultMessage: 'Two passwords that you enter is inconsistent!',
                })
            );
        } else {
            callback();
        }
    };

    comparePasswords = (rule, value, callback) => {
        const { form } = this.props;
        const { confirmDirty } = this.state;
        if (value && confirmDirty) {
            form.validateFields(['registerUserConfirmPassword'], { force: true });
        }
        callback();
    };

    passwordPolicy = (rule, value, callback) => {
        const {
            intl: { formatMessage },
        } = this.props;

        if (policyRegex.test(value)) {
            callback();
        }

        if (value.length < PASSWORD_MIN_LENGTH) {
            const msg = `${formatMessage({
                id: 'Form.passwordMustContain',
                defaultMessage: 'Must contain at least',
            })} ${PASSWORD_MIN_LENGTH} ${formatMessage({
                id: 'Form.characters',
                defaultMessage: `characters`,
            })}`;
            callback(msg);
        }

        if (!numericRegex.test(value)) {
            const msg = `${formatMessage({
                id: 'Form.passwordMustContain',
                defaultMessage: 'Must contain at least',
            })} 1 ${formatMessage({ id: 'Form.number', defaultMessage: 'number' })}`;
            callback(msg);
        }

        if (!uppercaseRegex.test(value)) {
            const msg = `${formatMessage({
                id: 'Form.passwordMustContain',
                defaultMessage: 'Must contain at least',
            })} 1 ${formatMessage({
                id: 'Form.upperCaseCharacter',
                defaultMessage: 'uppercase character',
            })}`;
            callback(msg);
        }

        callback(
            formatMessage({
                id: 'passwordRequirementsFail',
                defaultMessage: 'Does not meet the password requirements',
            })
        );
    };

    render() {
        const { form, classes, intl } = this.props;
        return (
            <Grid className={classes.root}>
                <Grid container direction="row" alignItems="center" className={classes.items}>
                    <Typography className={classes.formName} variant="body1">
                        <FormattedMessage id="General.email" defaultMessage="Email" />
                    </Typography>

                    <Grid className={classes.formInput}>
                        <FormInput
                            isRequired
                            fullWidth={false}
                            form={form}
                            type="email"
                            formItemKey="registerUserEmail"
                            placeholder="john@doe.com"
                            additionalRules={[
                                {
                                    type: 'email',
                                    message: intl.formatMessage({ id: 'Form.field.email' }),
                                },
                            ]}
                        />
                    </Grid>
                </Grid>

                <Grid container direction="row" alignItems="center" className={classes.items}>
                    <Typography className={classes.formName} variant="body1">
                        <FormattedMessage id="General.firstName" defaultMessage="First name" />
                    </Typography>

                    <Grid className={classes.formInput}>
                        <FormInput
                            isRequired
                            fullWidth={false}
                            form={form}
                            type="text"
                            formItemKey="registerUserFirstName"
                            placeholder="John"
                        />
                    </Grid>
                </Grid>

                <Grid container direction="row" alignItems="center" className={classes.items}>
                    <Typography className={classes.formName} variant="body1">
                        <FormattedMessage id="General.lastName" defaultMessage="Last name" />
                    </Typography>

                    <Grid className={classes.formInput}>
                        <FormInput
                            isRequired
                            fullWidth={false}
                            form={form}
                            type="text"
                            formItemKey="registerUserLastName"
                            placeholder="Doe"
                        />
                    </Grid>
                </Grid>

                <Grid container direction="row" alignItems="center" className={classes.items}>
                    <Typography className={classes.formName} variant="body1">
                        <FormattedMessage id="General.password" defaultMessage="Password" />
                    </Typography>

                    <Grid className={classes.formInput}>
                        <FormInput
                            isRequired
                            fullWidth={false}
                            form={form}
                            type="password"
                            formItemKey="registerUserPassword"
                            additionalRules={[
                                {
                                    validator: this.comparePasswords,
                                },
                                {
                                    validator: this.passwordPolicy,
                                },
                            ]}
                        />
                    </Grid>
                </Grid>

                <Grid container direction="row" alignItems="center" className={classes.items}>
                    <Typography className={classes.formName} variant="body1">
                        <FormattedMessage id="General.confirm.password" defaultMessage="Password" />
                    </Typography>

                    <Grid className={classes.formInput}>
                        <FormInput
                            isRequired
                            fullWidth={false}
                            form={form}
                            type="password"
                            formItemKey="registerUserConfirmPassword"
                            onClick={this.handleConfirmBlur}
                            additionalRules={[
                                {
                                    validator: this.compareToFirstPassword,
                                },
                            ]}
                        />
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

export default withStyles(styles)(injectIntl(RegisterUser));
